module.exports = "<div class=\"igx-card\" role=\"group\">\n    <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/card/card.component.html
// module id = 130
// module chunks = 0 1